import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EReprocessService } from '../../components/conversation-data/components/reprocessing-tools/reprocessing-tools.component';
import { TDataQueryName } from '../configurations/router';

@Injectable({
  providedIn: 'root',
})
export class ReprocessService {
  constructor(private readonly http: HttpClient) {}

  reprocessServices(services: EReprocessService[], query: TDataQueryName, id: string): Observable<void> {
    return this.http.post<void>(`reprocess-transcript/${query}/${id}`, services);
  }
}
